import { Box, Button, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { paymentWatcher } from '../../../redux/actionCreators/user/currentOrder'
import Service from '../../../services/user/currentOrder'

// Where Cashfree sends the browser back to. The payment result is read from
// Cashfree itself rather than from the redirect, then the booking is confirmed.
function VerifyPayment() {
    const { id } = useParams()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [msg, setMsg] = useState('Verifying your payment...')

    useEffect(() => {
        // Saved before leaving for Cashfree: the vendor's cart lines this payment is for
        let checkout = {}
        try { checkout = JSON.parse(sessionStorage.getItem('pendingCheckout')) || {} } catch (e) { }

        const verify = async () => {
            try {
                const { data } = await Service.verifyCashfree({ order_id: id, nCafeteriaId: checkout.nCafeteriaId, dOrderDate: checkout.dOrderDate })

                if (data.order_status === 'PAID') {
                    const payload = {
                        nOrderID: data.order_tags?.OrderNID,
                        cOrderID: data.order_tags?.OrderID,
                        nTotalRate: data.order_amount,
                        cPaymentStatus: 'Y',
                        cPaymentDesc: 'Success',
                        cBankTrackingID: data.order_id,
                        cReferenceID: `${data.cf_order_id}`,
                        nUserID: data.customer_details?.customer_id,
                        ...checkout,
                        nCafeteriaId: data.order_tags?.cafeteriaId || checkout.nCafeteriaId
                    };
                    dispatch(paymentWatcher(payload, navigate))
                    setMsg('This order is paid!')
                } else {
                    setMsg('Order has not been paid!')
                }
            }
            catch (e) {
                setMsg('We could not verify this payment. Please check your order history.')
            }
        }
        verify()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    return (
        <Box sx={{ textAlign: 'center', mt: '100px' }}>
            <Typography variant='t18_600'>{msg}</Typography>
            <Box mt='20px'>
                <Button variant="contained" component={Link} to='/user' type='button'>
                    Home
                </Button>
            </Box>
        </Box>
    )
}

export default VerifyPayment
